/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiResponse1Boolean,
  ApiResponse1BreadcrumbListResponse,
  ApiResponse1DownloadListResponse,
  ApiResponse1DuplicateEntryResponse,
  ApiResponse1EntryDetailResponse,
  ApiResponse1FileResponse,
  ApiResponse1GetEntryCountResult,
  ApiResponse1List1,
  ApiResponse1MoveEntryResponse,
  ApiResponse1VersionListResponse,
  MicrosoftAspNetCoreMvcProblemDetails,
  RevisdomAPIViewModelsEntryChangeEntriesStatusRequest,
  RevisdomAPIViewModelsEntryDeleteEntriesRequest,
  RevisdomAPIViewModelsEntryDuplicateEntryRequest,
  RevisdomAPIViewModelsEntryMoveEntryRequest,
  RevisdomApplicationFeaturesEntriesCommandsFixVersionPathsFixVersionPathsResult,
} from '../models/index';
import {
    ApiResponse1BooleanFromJSON,
    ApiResponse1BooleanToJSON,
    ApiResponse1BreadcrumbListResponseFromJSON,
    ApiResponse1BreadcrumbListResponseToJSON,
    ApiResponse1DownloadListResponseFromJSON,
    ApiResponse1DownloadListResponseToJSON,
    ApiResponse1DuplicateEntryResponseFromJSON,
    ApiResponse1DuplicateEntryResponseToJSON,
    ApiResponse1EntryDetailResponseFromJSON,
    ApiResponse1EntryDetailResponseToJSON,
    ApiResponse1FileResponseFromJSON,
    ApiResponse1FileResponseToJSON,
    ApiResponse1GetEntryCountResultFromJSON,
    ApiResponse1GetEntryCountResultToJSON,
    ApiResponse1List1FromJSON,
    ApiResponse1List1ToJSON,
    ApiResponse1MoveEntryResponseFromJSON,
    ApiResponse1MoveEntryResponseToJSON,
    ApiResponse1VersionListResponseFromJSON,
    ApiResponse1VersionListResponseToJSON,
    MicrosoftAspNetCoreMvcProblemDetailsFromJSON,
    MicrosoftAspNetCoreMvcProblemDetailsToJSON,
    RevisdomAPIViewModelsEntryChangeEntriesStatusRequestFromJSON,
    RevisdomAPIViewModelsEntryChangeEntriesStatusRequestToJSON,
    RevisdomAPIViewModelsEntryDeleteEntriesRequestFromJSON,
    RevisdomAPIViewModelsEntryDeleteEntriesRequestToJSON,
    RevisdomAPIViewModelsEntryDuplicateEntryRequestFromJSON,
    RevisdomAPIViewModelsEntryDuplicateEntryRequestToJSON,
    RevisdomAPIViewModelsEntryMoveEntryRequestFromJSON,
    RevisdomAPIViewModelsEntryMoveEntryRequestToJSON,
    RevisdomApplicationFeaturesEntriesCommandsFixVersionPathsFixVersionPathsResultFromJSON,
    RevisdomApplicationFeaturesEntriesCommandsFixVersionPathsFixVersionPathsResultToJSON,
} from '../models/index';

export interface ApiEntryBreadcrumbUrlGetRequest {
    url: string;
}

export interface ApiEntryChangeStatusPostRequest {
    revisdomAPIViewModelsEntryChangeEntriesStatusRequest?: RevisdomAPIViewModelsEntryChangeEntriesStatusRequest;
}

export interface ApiEntryCountGetRequest {
    startDate?: Date;
}

export interface ApiEntryDeleteRequest {
    revisdomAPIViewModelsEntryDeleteEntriesRequest?: RevisdomAPIViewModelsEntryDeleteEntriesRequest;
}

export interface ApiEntryDuplicatePostRequest {
    revisdomAPIViewModelsEntryDuplicateEntryRequest?: RevisdomAPIViewModelsEntryDuplicateEntryRequest;
}

export interface ApiEntryGetRequest {
    projectId?: number;
    folderId?: number;
}

export interface ApiEntryMovePostRequest {
    revisdomAPIViewModelsEntryMoveEntryRequest?: RevisdomAPIViewModelsEntryMoveEntryRequest;
}

export interface ApiEntrySummaryGetRequest {
    status?: ApiEntrySummaryGetStatusEnum;
    scope?: ApiEntrySummaryGetScopeEnum;
    startDate?: Date;
}

export interface ApiEntryUploadWithPathPostRequest {
    projectId?: number;
    folderId?: number;
    relativePath?: string;
    file?: Blob;
    thumbnail?: Blob;
}

export interface ApiEntryUrlDownloadLinksGetRequest {
    url: string;
}

export interface ApiEntryUrlGetRequest {
    url: string;
}

/**
 * 
 */
export class EntryApi extends runtime.BaseAPI {

    /**
     * Bu endpoint bir UUID\'deki entry\'nin breadcrumb (hierarchical path) bilgisini verir. EntryPath UUID\'si göndermeniz beklenir.
     * Bir UUID\'deki entry\'nin breadcrumb bilgisini verir.
     */
    async apiEntryBreadcrumbUrlGetRaw(requestParameters: ApiEntryBreadcrumbUrlGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiResponse1BreadcrumbListResponse>> {
        if (requestParameters['url'] == null) {
            throw new runtime.RequiredError(
                'url',
                'Required parameter "url" was null or undefined when calling apiEntryBreadcrumbUrlGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Entry/breadcrumb/{url}`.replace(`{${"url"}}`, encodeURIComponent(String(requestParameters['url']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponse1BreadcrumbListResponseFromJSON(jsonValue));
    }

    /**
     * Bu endpoint bir UUID\'deki entry\'nin breadcrumb (hierarchical path) bilgisini verir. EntryPath UUID\'si göndermeniz beklenir.
     * Bir UUID\'deki entry\'nin breadcrumb bilgisini verir.
     */
    async apiEntryBreadcrumbUrlGet(requestParameters: ApiEntryBreadcrumbUrlGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiResponse1BreadcrumbListResponse> {
        const response = await this.apiEntryBreadcrumbUrlGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * **Required Roles:** Admin, SuperAdmin, Editor  Bu endpoint array içerisinde iletilen entry\'nin statülerini değiştirir.
     * Verilen entry\'lerin statülerini değiştirir.
     */
    async apiEntryChangeStatusPostRaw(requestParameters: ApiEntryChangeStatusPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiResponse1Boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Entry/change-status`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RevisdomAPIViewModelsEntryChangeEntriesStatusRequestToJSON(requestParameters['revisdomAPIViewModelsEntryChangeEntriesStatusRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponse1BooleanFromJSON(jsonValue));
    }

    /**
     * **Required Roles:** Admin, SuperAdmin, Editor  Bu endpoint array içerisinde iletilen entry\'nin statülerini değiştirir.
     * Verilen entry\'lerin statülerini değiştirir.
     */
    async apiEntryChangeStatusPost(requestParameters: ApiEntryChangeStatusPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiResponse1Boolean> {
        const response = await this.apiEntryChangeStatusPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Bu endpoint kayıtlı tüm entrylerin sayısını verir. Entry status\'üne ya da tarihe göre filtreleme yapabilirsiniz.
     * Sistemdeki tüm entrylerin sayısını verir.
     */
    async apiEntryCountGetRaw(requestParameters: ApiEntryCountGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiResponse1GetEntryCountResult>> {
        const queryParameters: any = {};

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = (requestParameters['startDate'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Entry/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponse1GetEntryCountResultFromJSON(jsonValue));
    }

    /**
     * Bu endpoint kayıtlı tüm entrylerin sayısını verir. Entry status\'üne ya da tarihe göre filtreleme yapabilirsiniz.
     * Sistemdeki tüm entrylerin sayısını verir.
     */
    async apiEntryCountGet(requestParameters: ApiEntryCountGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiResponse1GetEntryCountResult> {
        const response = await this.apiEntryCountGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * **Required Roles:** Admin, SuperAdmin, Editor  Bu endpoint array içerisinde iletilen entry\'leri siler.
     * Verilen entry\'leri siler.
     */
    async apiEntryDeleteRaw(requestParameters: ApiEntryDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiResponse1Boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Entry`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: RevisdomAPIViewModelsEntryDeleteEntriesRequestToJSON(requestParameters['revisdomAPIViewModelsEntryDeleteEntriesRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponse1BooleanFromJSON(jsonValue));
    }

    /**
     * **Required Roles:** Admin, SuperAdmin, Editor  Bu endpoint array içerisinde iletilen entry\'leri siler.
     * Verilen entry\'leri siler.
     */
    async apiEntryDelete(requestParameters: ApiEntryDeleteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiResponse1Boolean> {
        const response = await this.apiEntryDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * **Required Roles:** Admin, SuperAdmin, Editor  
     * Folder veya File entry\'sini duplicate eder. Folder ise alt folder/file/version\'lar aynı hiyerarşi ile kopyalanır; version comment\'leri kopyalanmaz.
     */
    async apiEntryDuplicatePostRaw(requestParameters: ApiEntryDuplicatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiResponse1DuplicateEntryResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Entry/duplicate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RevisdomAPIViewModelsEntryDuplicateEntryRequestToJSON(requestParameters['revisdomAPIViewModelsEntryDuplicateEntryRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponse1DuplicateEntryResponseFromJSON(jsonValue));
    }

    /**
     * **Required Roles:** Admin, SuperAdmin, Editor  
     * Folder veya File entry\'sini duplicate eder. Folder ise alt folder/file/version\'lar aynı hiyerarşi ile kopyalanır; version comment\'leri kopyalanmaz.
     */
    async apiEntryDuplicatePost(requestParameters: ApiEntryDuplicatePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiResponse1DuplicateEntryResponse> {
        const response = await this.apiEntryDuplicatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * **Required Roles:** SuperAdmin  
     * Mevcut Version kayıtlarının Path alanını EntryPath.Url + \"#\" + Name ile günceller (tek seferlik, test/prod için).
     */
    async apiEntryFixVersionPathsPostRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RevisdomApplicationFeaturesEntriesCommandsFixVersionPathsFixVersionPathsResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Entry/fix-version-paths`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RevisdomApplicationFeaturesEntriesCommandsFixVersionPathsFixVersionPathsResultFromJSON(jsonValue));
    }

    /**
     * **Required Roles:** SuperAdmin  
     * Mevcut Version kayıtlarının Path alanını EntryPath.Url + \"#\" + Name ile günceller (tek seferlik, test/prod için).
     */
    async apiEntryFixVersionPathsPost(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RevisdomApplicationFeaturesEntriesCommandsFixVersionPathsFixVersionPathsResult> {
        const response = await this.apiEntryFixVersionPathsPostRaw(initOverrides);
        return await response.value();
    }

    /**
     * Bu endpoint bir projenin altındaki folder ve file\'ları verir. Proje id\'si göndermeniz beklenir.
     * Bir Projenin bir altındaki folder ve file\'ları verir.
     */
    async apiEntryGetRaw(requestParameters: ApiEntryGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiResponse1List1>> {
        const queryParameters: any = {};

        if (requestParameters['projectId'] != null) {
            queryParameters['projectId'] = requestParameters['projectId'];
        }

        if (requestParameters['folderId'] != null) {
            queryParameters['folderId'] = requestParameters['folderId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Entry`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponse1List1FromJSON(jsonValue));
    }

    /**
     * Bu endpoint bir projenin altındaki folder ve file\'ları verir. Proje id\'si göndermeniz beklenir.
     * Bir Projenin bir altındaki folder ve file\'ları verir.
     */
    async apiEntryGet(requestParameters: ApiEntryGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiResponse1List1> {
        const response = await this.apiEntryGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * **Required Roles:** Admin, SuperAdmin, Editor  
     * Folder veya File entry\'sini başka bir proje/folder altına taşır. Kullanıcı listesi target parent/project\'ten alınır, scope değişirse URL prefix\'i güncellenir.
     */
    async apiEntryMovePostRaw(requestParameters: ApiEntryMovePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiResponse1MoveEntryResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Entry/move`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RevisdomAPIViewModelsEntryMoveEntryRequestToJSON(requestParameters['revisdomAPIViewModelsEntryMoveEntryRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponse1MoveEntryResponseFromJSON(jsonValue));
    }

    /**
     * **Required Roles:** Admin, SuperAdmin, Editor  
     * Folder veya File entry\'sini başka bir proje/folder altına taşır. Kullanıcı listesi target parent/project\'ten alınır, scope değişirse URL prefix\'i güncellenir.
     */
    async apiEntryMovePost(requestParameters: ApiEntryMovePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiResponse1MoveEntryResponse> {
        const response = await this.apiEntryMovePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Bu endpoint kayıtlı tüm entryleri verir. Entry status\'üne ya da tarihe göre filtreleme yapabilirsiniz.
     * Sistemdeki tüm entryleri verir.
     */
    async apiEntrySummaryGetRaw(requestParameters: ApiEntrySummaryGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiResponse1VersionListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['scope'] != null) {
            queryParameters['scope'] = requestParameters['scope'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = (requestParameters['startDate'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Entry/summary`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponse1VersionListResponseFromJSON(jsonValue));
    }

    /**
     * Bu endpoint kayıtlı tüm entryleri verir. Entry status\'üne ya da tarihe göre filtreleme yapabilirsiniz.
     * Sistemdeki tüm entryleri verir.
     */
    async apiEntrySummaryGet(requestParameters: ApiEntrySummaryGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiResponse1VersionListResponse> {
        const response = await this.apiEntrySummaryGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * **Required Roles:** Admin, SuperAdmin, Editor  
     * relativePath ile klasör yolunu vererek dosya yükler. Eksik folder\'lar oluşturulur; mevcut olanlar kullanılır. Response, POST File ile aynı formatta döner.
     */
    async apiEntryUploadWithPathPostRaw(requestParameters: ApiEntryUploadWithPathPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiResponse1FileResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['projectId'] != null) {
            formParams.append('ProjectId', requestParameters['projectId'] as any);
        }

        if (requestParameters['folderId'] != null) {
            formParams.append('FolderId', requestParameters['folderId'] as any);
        }

        if (requestParameters['relativePath'] != null) {
            formParams.append('RelativePath', requestParameters['relativePath'] as any);
        }

        if (requestParameters['file'] != null) {
            formParams.append('File', requestParameters['file'] as any);
        }

        if (requestParameters['thumbnail'] != null) {
            formParams.append('Thumbnail', requestParameters['thumbnail'] as any);
        }

        const response = await this.request({
            path: `/api/Entry/upload-with-path`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponse1FileResponseFromJSON(jsonValue));
    }

    /**
     * **Required Roles:** Admin, SuperAdmin, Editor  
     * relativePath ile klasör yolunu vererek dosya yükler. Eksik folder\'lar oluşturulur; mevcut olanlar kullanılır. Response, POST File ile aynı formatta döner.
     */
    async apiEntryUploadWithPathPost(requestParameters: ApiEntryUploadWithPathPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiResponse1FileResponse> {
        const response = await this.apiEntryUploadWithPathPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Bu endpoint bir UUID\'deki entry\'nin altında bulunan tüm versionların url\'lerini döner. EntryPath UUID\'si göndermeniz beklenir.
     * Bir UUID\'deki entry\'nin altında bulunan tüm versionların url\'lerini döner.
     */
    async apiEntryUrlDownloadLinksGetRaw(requestParameters: ApiEntryUrlDownloadLinksGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiResponse1DownloadListResponse>> {
        if (requestParameters['url'] == null) {
            throw new runtime.RequiredError(
                'url',
                'Required parameter "url" was null or undefined when calling apiEntryUrlDownloadLinksGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Entry/{url}/download-links`.replace(`{${"url"}}`, encodeURIComponent(String(requestParameters['url']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponse1DownloadListResponseFromJSON(jsonValue));
    }

    /**
     * Bu endpoint bir UUID\'deki entry\'nin altında bulunan tüm versionların url\'lerini döner. EntryPath UUID\'si göndermeniz beklenir.
     * Bir UUID\'deki entry\'nin altında bulunan tüm versionların url\'lerini döner.
     */
    async apiEntryUrlDownloadLinksGet(requestParameters: ApiEntryUrlDownloadLinksGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiResponse1DownloadListResponse> {
        const response = await this.apiEntryUrlDownloadLinksGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Bu endpoint bir UUID\'deki entry\'nin detaylarını ve bir altındaki folder ve file\'ları verir. EntryPath UUID\'si göndermeniz beklenir.
     * Bir UUID\'deki entry\'nin detaylarını ve bir alt entry\'lerini verir.
     */
    async apiEntryUrlGetRaw(requestParameters: ApiEntryUrlGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiResponse1EntryDetailResponse>> {
        if (requestParameters['url'] == null) {
            throw new runtime.RequiredError(
                'url',
                'Required parameter "url" was null or undefined when calling apiEntryUrlGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Entry/{url}`.replace(`{${"url"}}`, encodeURIComponent(String(requestParameters['url']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponse1EntryDetailResponseFromJSON(jsonValue));
    }

    /**
     * Bu endpoint bir UUID\'deki entry\'nin detaylarını ve bir altındaki folder ve file\'ları verir. EntryPath UUID\'si göndermeniz beklenir.
     * Bir UUID\'deki entry\'nin detaylarını ve bir alt entry\'lerini verir.
     */
    async apiEntryUrlGet(requestParameters: ApiEntryUrlGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiResponse1EntryDetailResponse> {
        const response = await this.apiEntryUrlGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const ApiEntrySummaryGetStatusEnum = {
    NeedsReview: 'NeedsReview',
    Updated: 'Updated',
    Approved: 'Approved'
} as const;
export type ApiEntrySummaryGetStatusEnum = typeof ApiEntrySummaryGetStatusEnum[keyof typeof ApiEntrySummaryGetStatusEnum];
/**
 * @export
 */
export const ApiEntrySummaryGetScopeEnum = {
    Internal: 'Internal',
    External: 'External'
} as const;
export type ApiEntrySummaryGetScopeEnum = typeof ApiEntrySummaryGetScopeEnum[keyof typeof ApiEntrySummaryGetScopeEnum];
